import { render } from "./ApiTokensPage.vue?vue&type=template&id=800e7526&scoped=true"
import script from "./ApiTokensPage.vue?vue&type=script&lang=js"
export * from "./ApiTokensPage.vue?vue&type=script&lang=js"

import "./ApiTokensPage.vue?vue&type=style&index=0&id=800e7526&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800e7526"]])

export default __exports__